class ProductMediaGallery {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.init();
  }

  init() {
    this.setupThumbnails();
    this.setupZoom();
    this.setupQuantity();
    this.setupVariants();
  }

  setupThumbnails() {
    const thumbnails = this.container.querySelectorAll('.product-media-gallery__thumbnail');
    const mainItems = this.container.querySelectorAll('.product-media-gallery__item');
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.mediaId;
        thumbnails.forEach(t => t.classList.remove('active'));
        mainItems.forEach(item => item.classList.remove('active'));
        thumb.classList.add('active');
        const targetItem = this.container.querySelector(`.product-media-gallery__item[data-media-id="${mediaId}"]`);
        if (targetItem) targetItem.classList.add('active');
      });
    });
  }

  setupZoom() {
    const zoomContainers = this.container.querySelectorAll('.product-media-gallery__zoom-container');
    zoomContainers.forEach(container => {
      const zoomUrl = container.getAttribute('data-zoom-image');
      container.addEventListener('mouseenter', () => {
        if (window.innerWidth <= 990) return;
        container.style.backgroundImage = `url(${zoomUrl})`;
      });
      container.addEventListener('mousemove', (e) => {
        if (window.innerWidth <= 990) return;
        const rect = container.getBoundingClientRect();
        const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
        const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
        container.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
      });
      container.addEventListener('mouseleave', () => {
        container.style.backgroundImage = 'none';
      });
    });
  }

  setupQuantity() {
    const buttons = this.container.querySelectorAll('.quantity-button');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const action = button.dataset.action;
        const input = button.parentElement.querySelector('.quantity-input');
        let value = parseInt(input.value) || 1;
        if (action === 'increase') value++;
        else if (action === 'decrease' && value > 1) value--;
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  setupVariants() {
    const variantDataScript = document.getElementById(`product-variants-json-${this.sectionId}`);
    const moneyFormatInput = document.getElementById(`money-format-${this.sectionId}`);
    if (!variantDataScript || !moneyFormatInput) return;
    this.variants = JSON.parse(variantDataScript.textContent);
    this.moneyFormat = moneyFormatInput.value;
    const variantInputs = this.container.querySelectorAll('.product-variant-values input[type="radio"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => this.updateCurrentVariant());
    });
  }

  updateCurrentVariant() {
    const fieldsets = Array.from(this.container.querySelectorAll('.product-variant-values'));
    const selectedOptions = fieldsets.map(fieldset => {
      const checkedInput = fieldset.querySelector('input:checked');
      return checkedInput ? checkedInput.value : null;
    });
    const matchedVariant = this.variants.find(variant => {
      return selectedOptions.every((option, index) => variant.options[index] === option);
    });
    this.renderVariantState(matchedVariant);
  }

  renderVariantState(variant) {
    const addToCartBtn = this.container.querySelector('.product-add-to-cart');
    const priceContainer = this.container.querySelector('.product-price .price__container');
    const skuContainer = this.container.querySelector('.product-sku');
    const skuValue = skuContainer ? skuContainer.querySelector('.product-sku__value') : null;
    const hiddenInput = this.container.querySelector('input[name="id"]');
    
    const addText = addToCartBtn.dataset.addToCartText;
    const soldOutText = addToCartBtn.dataset.soldOutText;
    const unavailableText = addToCartBtn.dataset.unavailableText;

    if (!variant) {
      addToCartBtn.disabled = true;
      addToCartBtn.querySelector('span').textContent = unavailableText;
      if (skuContainer && skuValue) {
        skuValue.textContent = '';
        skuContainer.classList.add('hidden');
      }
      return;
    }

    if(hiddenInput) hiddenInput.value = variant.id;
    window.history.replaceState({ }, '', `${window.location.pathname}?variant=${variant.id}`);
    
    addToCartBtn.disabled = !variant.available;
    addToCartBtn.querySelector('span').textContent = variant.available ? addText : soldOutText;

    if (priceContainer) {
      if (variant.compare_at_price > variant.price) {
        priceContainer.innerHTML = `<div class="price__sale"><span class="price-item price-item--sale">${this.formatMoney(variant.price, this.moneyFormat)}</span><span class="price-item price-item--regular" style="margin-left: 10px; color: #888;"><s>${this.formatMoney(variant.compare_at_price, this.moneyFormat)}</s></span></div>`;
      } else {
        priceContainer.innerHTML = `<div class="price__regular"><span class="price-item price-item--regular">${this.formatMoney(variant.price, this.moneyFormat)}</span></div>`;
      }
    }

    if (skuContainer && skuValue) {
      skuValue.textContent = variant.sku || '';
      skuContainer.classList.toggle('hidden', !variant.sku);
    }

    if (variant.featured_media) {
       const thumb = this.container.querySelector(`.product-media-gallery__thumbnail[data-media-id="${variant.featured_media.id}"]`);
       if(thumb) thumb.click();
    }
  }

  formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '€{{amount}}';
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    let value = '';
    const match = formatString.match(placeholderRegex);
    if (!match) return cents;
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    }
    return formatString.replace(placeholderRegex, value);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-product-section').forEach(container => {
    new ProductMediaGallery(container);
  });
});
